import { Button, FormControl, InputLabel, Select, Stack } from '@mui/material'
import { GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro'
import { Clear } from '@mui/icons-material'
import { useUserContext } from '../../../Contexts/UserConfig'
import { stackGap } from '../../../Constants&Theme/Spacing'
import * as React from 'react'
import { listFromCodes, listFromKV } from '../../../Functions/ListItemGenerator'
import { useHealthContext } from '../../../Contexts/Modules/HealthModule/HealthModule'

export interface ScreenFilters {
  FacilityID: string | number
  StatusID: string | number
}
function ScreenReportDGToolbar({
  dgFilters,
  setDGFilters,
  manifest,
}: {
  dgFilters: ScreenFilters
  setDGFilters: any
  manifest: boolean
}) {
  const { loginConfig, loadingConfig } = useUserContext()
  const { screenFacilityQuery } = useHealthContext()

  return (
    <GridToolbarContainer sx={{ width: 1, p: 1 }}>
      <Stack
        direction={'row'}
        gap={stackGap.row / 2}
        width={1}
        display={'flex'}
      >
        <GridToolbarExport
          csvOptions={{ allColumns: true }}
          printOptions={{ disableToolbarButton: true }}
        />
        <FormControl
          size="small"
          sx={{ flex: 1 }}
        >
          <InputLabel>Recipient Lab</InputLabel>
          <Select
            inputProps={{ 'aria-label': 'FacilityInput' }}
            label={'Recipient Lab'}
            value={dgFilters?.FacilityID ?? ''}
            onChange={(e) =>
              setDGFilters((f: any) => {
                return { ...f, FacilityID: e.target.value }
              })
            }
          >
            {listFromKV(
              screenFacilityQuery.data ?? [],
              screenFacilityQuery.isLoading,
              dgFilters?.FacilityID,
            )}
          </Select>
        </FormControl>
        {!manifest && (
          <FormControl
            size="small"
            sx={{ flex: 1 }}
          >
            <InputLabel>Status</InputLabel>
            <Select
              inputProps={{ 'aria-label': 'StatusInput' }}
              label={'Status'}
              value={dgFilters?.StatusID ?? ''}
              onChange={(e) =>
                setDGFilters((f: any) => {
                  return { ...f, StatusID: e.target.value }
                })
              }
            >
              {listFromCodes(loginConfig, 'SampleStatusID', loadingConfig)}
            </Select>
          </FormControl>
        )}
        <Button
          variant={'outlined'}
          startIcon={<Clear />}
          color={'warning'}
          onClick={() => setDGFilters({})}
        >
          Clear Filters
        </Button>
      </Stack>
    </GridToolbarContainer>
  )
}

export default ScreenReportDGToolbar
